
















































import Vue, { PropType } from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import NavigationButton from "@/components/NavigationButton.vue";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";
import PartnerInfo from "../detailViews/PartnerInfo.vue";
import IfaceSyncPartnerDTO from "../../models/IfaceSyncPartnerDTO";
import store from "../../services/InterfaceStore";

interface Props {
  /** Csoportosító külső azonosító (a fejlécben és a search-en is ezt használja) */
  extCode: string;
  /** Az aktuális partner rekord (kompakt összegzéshez) */
  partner: IfaceSyncPartnerDTO | null;
}

interface Computed {
  url: string;
  apiSearchName: string;
  columns: any[];
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "PartnerHistory",

  components: {
    ApiSearchPage,
    NavigationButton,
    SyncStatusBadge,
    DateTimeDisplay,
    PartnerInfo,
  },

  props: {
    extCode: { type: String, default: "" },
    partner: { type: Object as PropType<IfaceSyncPartnerDTO | null>, default: null },
  },

  computed: {
    url(): string {
      return `iface-sync-partner/history-search/${store.selectedInterface}/${encodeURIComponent(this.extCode)}`;
    },

    apiSearchName(): string {
      return `PartnerHistoryApiSearch_${this.extCode}`;
    },

    columns(): any[] {
      return [
        { field: "id", title: "", width: 45, filterable: false, sortable: false, cell: "command" },
        { field: "updDateTime", title: "Időpont", width: 110, filterable: false, cell: "updDateTime" },
        { field: "syncStatusName", title: "Státusz", width: 140, cell: "syncStatusName" },
        { field: "name", title: "Név", cell: "disabledText" },
        { field: "taxaccount", title: "Adószám", width: 140, cell: "disabledText" },
        { field: "euTaxaccount", title: "EU adószám", width: 140, cell: "disabledText" },
        { field: "city", title: "Város", width: 130, cell: "disabledText" },
        { field: "address", title: "Cím", cell: "disabledText" },
        { field: "errorText", title: "Hibaüzenet", width: 200, cell: "disabledText" },
        { field: "syncRemark", title: "Megjegyzés", width: 180, cell: "disabledText" },
        { field: "updUserName", title: "Módosította", width: 130, cell: "disabledText" },
      ];
    },
  },
});
